
export default {
  name: 'AdRotationBanner', 
  props: { 
    bannerArray: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      randomItem: {},
    }
  },
  computed: {},
  mounted() {
    this.randomItem = this.weightedRandomPick(this.bannerArray);
  },
  methods: {
    weightedRandomPick(array) {
      let totalWeight = array.reduce((sum, item) => sum + item.weight, 0);
      let randomNum = Math.random() * totalWeight;
      for(let i = 0; i < array.length; i++) {
        if(randomNum < array[i].weight) {
          return array[i];
        }
        randomNum -= array[i].weight;
      }
    }
  }
}
